import React, { Component } from 'react';
import { Container, Row, Col, Form, Table, Button, Modal, Alert, Badge } from 'react-bootstrap';
import { connect } from 'react-redux';
import apiUrl from '../../utils/apiUrl';
import AppSpinner from '../AppSpinner/AppSpinner';
import './styles/styles.scss';

const select = state => {
  return {
    token: state.auth.token
  };
};

class ConnectedAdminsComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      users: [],
      show: false,
      showRemoveModal: false,
      search: '',
      newUserEmail: '',
      userToRemove: '',
      role: 'ADMIN',
      userCreated: false,
      creatingUser: false,
      removingUser: false,
      userRemoved: false,
      errorRemove: false,
      error: false,
      loading: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseRemoveModal = this.handleCloseRemoveModal.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.updateAdmins = this.updateAdmins.bind(this);
  }

  handleClose() {
    this.setState({
      show: false,
      newUserEmail: '',
      role: 'ADMIN',
      userCreated: false,
      creatingUser: false,
      error: false
    });
  }

  handleCloseRemoveModal() {
    this.setState({
      showRemoveModal: false,
      removingUser: false,
      userRemoved: false,
      errorRemove: false
    });
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  async handleRemove() {
    this.setState({ removingUser: true });

    const { userToRemove } = this.state;
    const { token } = this.props;

    const newUserProm = await fetch(`${apiUrl}/admin/admin/users/delete?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        adminId: userToRemove
      })
    });

    const resp = await newUserProm.json();

    if (resp.success) this.setState({ userRemoved: true });
    else this.setState({ errorRemove: true });

    await this.updateAdmins();
    this.setState({ removingUser: false });
  }

  async handleCreate() {

    this.setState({ creatingUser: true });

    const { newUserEmail } = this.state;
    const { token } = this.props;

    const newUserProm = await fetch(`${apiUrl}/admin/admin/users/create?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userEmail: newUserEmail
      })
    });

    const resp = await newUserProm.json();

    if (resp.success) this.setState({ userCreated: true });
    else this.setState({ error: true });

    await this.updateAdmins();
    this.setState({ creatingUser: false });
    
  }

  async updateAdmins() {
    const { token } = this.props;
    const usersProm = await fetch(`${apiUrl}/admin/admin/users/get?token=${token}`);
    const usersResp = await usersProm.json();

    if (usersResp.success) this.setState({ users: usersResp.admins });

    this.setState({ loading: false });
  }

  componentDidMount() {
    this.updateAdmins();  
  }

  render() {

    const {
      show,
      showRemoveModal,
      search,
      newUserEmail,
      userCreated,
      creatingUser,
      removingUser,
      userRemoved,
      errorRemove,
      error,
      users,
      role,
      loading
    } = this.state;

    const searchLowercase = search ? search.toLocaleLowerCase() : '';

    const filteredUsers = !search ? users :
    users.filter(us =>
      us.email.toLocaleLowerCase().includes(searchLowercase) ||
      us.firstName.toLocaleLowerCase().includes(searchLowercase) ||
      us.lastName.toLocaleLowerCase().includes(searchLowercase)
    );

    if (loading) return (<AppSpinner />);

    return (
      <div className="admins-component">
        <Container>
          <Row>
            <Col xs={12}>
              <h2>Administradores</h2>
              <hr />
            </Col>
            <Col xs={12}>
              <div className="search-bar">
                <Form.Group>
                  <Form.Control
                    name="search"
                    value={search}
                    onChange={this.handleInputChange}
                    type="text"
                    placeholder="Busca por nombre o correo"
                  />
                </Form.Group>

                <Button
                  className="nibi-btn"
                  onClick={() => this.setState({show: true})}
                >
                  Crear administrador
                </Button>
              </div>
            </Col>
            <Col xs={12}>
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Rol</th>
                    <th>Eliminar</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    filteredUsers.map((user, index) =>
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{`${user.firstName} ${user.lastName}`}</td>
                        <td>{user.email}</td>
                        <td>
                          <Badge variant="success">Administrador</Badge>
                        </td>
                        <td>
                          <Button variant="danger" onClick={() => this.setState({showRemoveModal: true, userToRemove: user._id})}>
                            Eliminar
                          </Button>
                        </td>
                      </tr>
                    )
                  }
                  
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>

        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Crear usuario</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            {
              creatingUser ? <AppSpinner /> :
              error ?
              <Alert variant="info">
                Error al crear el usuario. Inténtalo nuevamente.
              </Alert> :
              userCreated ?
              <Alert variant="info">
                Administrador creado correctamente.
              </Alert> :
              <>
                <Alert variant="info">
                  A continuación escribe el correo electrónico del usuario.
                  El usuario debe haber creado una cuenta en Nibi previamente.
                </Alert>

                <Form.Group>
                  <Form.Control
                    type="email"
                    placeholder="Correo"
                    name="newUserEmail"
                    value={newUserEmail}
                    onChange={this.handleInputChange}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Rol:</Form.Label>
                  <Form.Control
                    as="select"
                    name="role"
                    value={role}
                    onChange={this.handleInputChange}
                  >
                    <option value="ADMIN">Administrador</option>
                  </Form.Control>
                </Form.Group>

              </>
            }

          </Modal.Body>
          
          {
            !creatingUser &&
            <Modal.Footer>
              {
                (userCreated || error) ?
                <Button variant="primary" onClick={this.handleClose}>
                  Aceptar
                </Button> :
                <>
                  <Button variant="primary" onClick={this.handleCreate}>
                    Crear
                  </Button>
                  <Button variant="secondary" onClick={this.handleClose}>
                    Cerrar
                  </Button>
                </>
              }
              
            </Modal.Footer>
          }
          
        </Modal>

        <Modal show={showRemoveModal} onHide={this.handleCloseRemoveModal}>
          <Modal.Header closeButton>
            <Modal.Title>Eliminar administrador</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              removingUser ? <AppSpinner /> :
              errorRemove ?
              <Alert variant="info">
                Error al eliminar el usuario. Inténtalo nuevamente.
              </Alert> :
              userRemoved ?
              <Alert variant="info">
                Administrador eliminado.
              </Alert> :
              <Alert variant="danger">
                ¿Estás seguro de querer eliminar el usuario?
              </Alert>
            }

          </Modal.Body>
          
          {
            !removingUser &&
            <Modal.Footer>
              {
                (userRemoved || errorRemove) ?
                <Button variant="primary" onClick={this.handleCloseRemoveModal}>
                  Aceptar
                </Button> :
                <>
                  <Button variant="danger" onClick={this.handleRemove}>
                    Eliminar
                  </Button>
                  <Button variant="secondary" onClick={this.handleCloseRemoveModal}>
                    Cerrar
                  </Button>
                </>
              }
              
            </Modal.Footer>
          }
          
        </Modal>

      </div>
    );
  }
}

const AdminsComponent = connect(select)(ConnectedAdminsComponent);

export default AdminsComponent;
